import { useState, useEffect } from 'react';

const API_BASE = import.meta.env.VITE_API_URL || '';

interface PrizePoolData {
  prizePoolSol: number;
  prizePoolUsd: number | null;
  solPriceUsd: number | null;
  isLoading: boolean;
}

export function usePrizePool(): PrizePoolData {
  const [data, setData] = useState<PrizePoolData>({
    prizePoolSol: 0,
    prizePoolUsd: null,
    solPriceUsd: null,
    isLoading: true,
  });

  useEffect(() => {
    async function fetchPrizePool() {
      try {
        const response = await fetch(`${API_BASE}/api/transparency`);
        const result = await response.json();
        if (result.success && result.data) {
          const prizePoolSol = result.data.currentSeason?.prizePoolSol ?? 0;
          const solPriceUsd = result.data.solPriceUsd ?? null;
          const prizePoolUsd = solPriceUsd ? prizePoolSol * solPriceUsd : null;

          setData({
            prizePoolSol,
            prizePoolUsd,
            solPriceUsd,
            isLoading: false,
          });
        } else {
          setData(prev => ({ ...prev, isLoading: false }));
        }
      } catch (error) {
        console.error('Failed to fetch prize pool:', error);
        setData(prev => ({ ...prev, isLoading: false }));
      }
    }

    fetchPrizePool();
  }, []);

  return data;
}

// Format USD amount for display
export function formatPrizeUsd(amount: number | null): string {
  if (amount === null) return '—';
  if (amount >= 1000000) {
    return `$${(amount / 1000000).toFixed(2)}M`;
  }
  if (amount >= 1000) {
    return `$${(amount / 1000).toFixed(1)}K`;
  }
  return `$${amount.toFixed(0)}`;
}

// Format SOL amount for display
export function formatPrizeSol(amount: number): string {
  return `${amount.toFixed(2)} SOL`;
}
